export default "__VITE_ASSET__9c3969e8__"